<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#ee0909" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> cargando .... </p>
</ngx-spinner>

<div class="panel">
    <div class="row">
        <div class="container">
            <div class="col-sm-11">
                <img src="./assets/images/Elementos/Carruse01.jpg" class="carrucel" />

            </div>
        </div>
        <br>
    </div>

    <div class="row">
        <div class="container">
            <div class=" col-sm-12 leyenda3">
                <p>{{title}}</p>
            </div>
        </div>
    </div>
    <br>
    <div class="row" *ngIf="sector">
        <div class="container">
            <div class=" col-sm-12 leyenda">
                <p>Consulta aquí el catálogo donde puedes encontrar todos los estándares de competencia por ocupación</p>
            </div>
        </div>
    </div>
    <br>
   <!-- <div class="container">
        <div class="col-sm-1">
            <br>
            &nbsp; <span><img src="./assets/images/icon/lupa.png" class="iconLupa"></span>
        </div>
        <div class="col-sm-11">
            <mat-form-field appearance="standard">
                <mat-label>Búsqueda de sectores productivos por estándar</mat-label>
                <input matInput #message placeholder="Ingresa aquí las palabras claves del Estándar que deseas buscar"
                    (keyup)="getSectoresByEstandar($event)">
            </mat-form-field>
        </div>
    </div>-->

    <div class="row">
        <div class="container">
            <div *ngFor="let listado of listado  index as i" class="panel col-sm-4">
                <div class="panel">
                    <div class="img">
                        <img src="./assets/images/Elementos/{{listado.nombreImagen}}"
                            class="img-responsive imagen2 mi-cursor" (click)="sectorByID(listado)">
                    </div>
                    <br>
                    <div class="panel-heading2 mi-cursor  col-auto bg-danger p-5 tex-center" id={{i}}
                        (click)="sectorByID(listado)" *ngIf="listado.activo==1">
                        <p>{{listado.descripcion}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="panel panel-danger " *ngIf="nivel || ocupacion">
    <br>
    <div class="row">
        <div class="container">
            <div class="col-sm-5"></div>
            <div style="text-align: center;" class="col-sm-1">
                <button mat-button (click)="back()"><img src="./assets/images/icon/Atras.png"
                        class=" imagen" /></button>
            </div>
            <div style="text-align: center;" class="col-sm-1">
                <button mat-button (click)="home()"><img src="./assets/images/icon/Home.png" class=" imagen" /></button>
            </div>
        </div>
    </div>
    <br>
</div>